module.exports = "/call-frontend/img/撒点-黄.121b2c96.png";